package com.macrofocus.nastac.components

import ch.ethz.nastac.server.BuildKonfig
import com.macrofocus.nastac.LayerGroup
import com.macrofocus.nastac.Sizes
import com.macrofocus.nastac.ViewStyle
import com.macrofocus.nastac.theme.ThemeContext
import emotion.react.css
import mui.material.PaletteMode
import mui.material.TooltipPlacement
import mui.system.Box
import mui.system.sx
import org.mkui.react.toState
import react.*
import react.dom.html.ReactHTML
import web.cssom.Display
import web.cssom.pct
import web.cssom.px

val SidebarContent = FC<Props> {
    val DEBUG = false
    val ACCORDION = true

    var theme by use(ThemeContext)!!
    val nastac = useRequired(NASTACContext)

    val (viewStyleSelection, _) = nastac.dataLoader.viewStyleSelection.toState()

    Box {
        sx {
            width = Sizes.Sidebar.Width
            display = Display.inlineFlex
//            justifyContent = JustifyContent.center
        }

        mui.material.Tooltip {
            title = ReactNode("Nationalist State Transformation and Conflict (NASTAC) data platform v. ${BuildKonfig.nastacVersion}")
            placement = TooltipPlacement.right

            ReactHTML.img {
//            if(props.marginLeft != null) {
                css {
                    marginLeft = 10.px
                    marginTop = 9.px
                }
//            }
                src = "/NASTACdp-framed.svg"
                height = 40.0
            }
        }

        Logo {
//                sx { width = Sizes.Sidebar.Width }

            logo = if (theme.palette.mode == PaletteMode.light) "/eth_logo_kurz_pos.svg" else "/eth_logo_kurz_neg.svg"
            height = 40.0
            marginTop = 8.px
        }

        mui.material.Tooltip {
            title = ReactNode("This project has received funding from the European Research Council (ERC) under the European Union’s Horizon 2020 research and innovation programme (ERC Advanced Grant agreement No.787478 NASTAC)")
            placement = TooltipPlacement.bottomEnd

            ReactHTML.img {
//            if(props.marginLeft != null) {
                css {
                    marginLeft = 0.px
                    marginTop = 15.px
                }
//            }
                src = "/LOGO_ERC-FLAG_EU.svg"
                height = 30.0
            }
        }
    }

    Box {
        sx {
            width = 100.pct
//            height = 185.px
        }

        if(ACCORDION) {
            ViewStyleCustom {
                this.viewStyleProbing = nastac.dataLoader.viewStyleProbing
                this.viewStyleSelection = nastac.dataLoader.viewStyleSelection
                this.viewStyleExpansion = nastac.dataLoader.viewStyleExpansion
            }
        } else {
            ViewStyleLinks {
                this.viewStyleProbing = nastac.dataLoader.viewStyleProbing
                this.viewStyleSelection = nastac.dataLoader.viewStyleSelection
            }
        }
    }

    Box {
        sx {
            display = Display.inlineFlex
            marginTop = 24.px
            marginLeft = 10.px
        }

        TimeSlider {
            this.shiftValue = nastac.dataLoader.shiftValue
            this.localShiftValue = nastac.dataLoader.localShiftValue
            this.minYear = nastac.dataLoader.minYear
            this.maxYear = nastac.dataLoader.maxYear
            this.enabled = viewStyleSelection != ViewStyle.INTRO && viewStyleSelection != ViewStyle.REPLICATION && viewStyleSelection.layerGroup != LayerGroup.GEOPOLITICS
            this.valueEnabled = viewStyleSelection != ViewStyle.INTRO && viewStyleSelection != ViewStyle.REPLICATION
            this.playEnabled = viewStyleSelection != ViewStyle.INTRO && viewStyleSelection != ViewStyle.TILLY && viewStyleSelection != ViewStyle.REPLICATION && viewStyleSelection.layerGroup != LayerGroup.GEOPOLITICS
            this.steps = if(viewStyleSelection == ViewStyle.TILLY) 5 else 1
//            timeTracker = diviso.configuration.timeTracker
//            timeUnitChooser = false
//            valueLabelDisplay = "off"
//            width = 210.px
        }
    }
}